export const sentryEnvironment = {
    dsn: 'https://67abf70d36686659db4fe3047836bd23@o4508767103352832.ingest.de.sentry.io/4508772107485264',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 0.3,
};
